import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import axios from "axios";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import { alert, confirm } from 'devextreme/ui/dialog';
import Toolbar, { Item } from "devextreme-react/toolbar";
import { GetFormatedDateWithTime } from '../../../../common/Utils'
import { custom } from 'devextreme/ui/dialog';
import ValidationSummary from 'devextreme-react/validation-summary';
import PrimaryTab from "./tabs/PrimaryTab";
import StatusTab from "./tabs/StatusTab";
import AdditionalTab from "./tabs/AdditionalTab";
import DataSource from "devextreme/data/data_source";
import { createStore } from 'devextreme-aspnet-data-nojquery'
import UOMTab from "./tabs/UOMTab";
import LotTab from "./tabs/LotTab";
import UserDefinedTab from "./tabs/UserDefinedTab";
import HandlingTab from "./tabs/HandlingTab";
import KitTab from "./tabs/KitTab";
import SerialNumberTab from "../../common/SerialNumberTab";
import ChargesTab from "../../common/ChargesTab";
import LocationsTab from "../../common/LocationsTab";
import data from "../../../../assets/apiRoutes.json";
import { RECORD_TYPE, ItemDataEntryRoutes, ItemDataProfileRoutes, EMPTY_GUID } from "../../../../const/constants";
import UnavailableTab from "../../common/UnavailableTab";

var skipDataLoading = false;
var reOrderMethodFlag = false;
var perviousItemType = null;
var profile = null;
var currentR_IDENTITY = null;
var currentRATESELECTION = 'N';
var currentCLASSCODE = null;
var currentSUBCLASSCODE = null;

function Form(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    // Declared before readProfileDefaults because initialFormFields calls that helper while this
    // module is still initialising - reading formFieldsRef any later would be a temporal-dead-zone
    // ReferenceError on the ordinary item path, where the URL check below does not short-circuit.
    // Starts null rather than mirroring initialFormFields (which does not exist yet); the effect
    // further down syncs it after every commit, and its only other reader is handleFieldChange,
    // which cannot run before mount.
    const formFieldsRef = useRef(null);

    // Single source of truth for the profile-defaults route (Item Data Profile -> Item Defaults).
    // Read from the live URL, not props: onFormLoad and the widgets' onValueChanged both run
    // closures captured before props were populated, so a props-derived value goes stale in exactly
    // the places that matter. formFieldsRef is the second source because an existing 'P' record
    // opened for edit carries the record type in state without recordType being in the URL.
    // Declared here so initialFormFields below can use it; formFieldsRef is only read on call.
    const readProfileDefaults = () => {
        const params = new URLSearchParams(window.location.search);
        return {
            isProfileDefaults:
                params.get('recordType') === RECORD_TYPE.PROFILE_DEFAULTS
                || formFieldsRef.current?.RECORDTYPE === RECORD_TYPE.PROFILE_DEFAULTS,
            profileRowId: params.get('RProfile'),
            profileCode: params.get('profileCode'),
        };
    };

    const { isProfileDefaults } = readProfileDefaults();

    const initialFormFields = {
        ROWID: '00000000-0000-0000-0000-000000000000',
        KEYSEQUENCE: 1,
        CREATIONDATETIME: null,
        CREATIONUSERID: '',
        LASTUPDATEDATETIME: null,
        LASTUPDATEUSERID: '',
        COMPANYID: '',
        MODULE: 'WM',
        // 'P' when the Item Data Profile screen opened this form via its Item Defaults button
        // (?recordType=P); 'R' for an ordinary item.
        RECORDTYPE: readProfileDefaults().isProfileDefaults ? RECORD_TYPE.PROFILE_DEFAULTS : RECORD_TYPE.REAL,
        R_PROFILE: '',
        ITEMCODE: '',
        R_WAREHOUSE: '',
        DESCRIPTION_1: '',
        DESCRIPTION_2: '',
        R_IDENTITY: '',
        IDENTITYID: '',
        R_OEMMANUFACTUREID: '',
        OEMMANUFACTURERCODE: '',
        R_DESTINATIONID: '',
        CLASSCODE: '',
        SUBCLASSCODE: '',
        ITEMTYPE: 'I',
        ABCCODE: '',
        STATUS: 'A',
        STATUSREASONCODE: '',
        TAXSTATUS: 'Y',
        COMMENT: '',
        LOCATIONTYPE: 'W',
        R_LOCATION: '',
        PHYSICALCOUNTCODE: '',
        FREIGHTCLASSCODE: '',
        R_GLDEPARTMENT: '',
        R_CAJOBCODE: '',
        INVENTORYUNITUOM: '',
        PIECESPERUNITUOM: '',
        PIECESPERUNITQUANTITY: null,
        UNITSPERPACKAGEUOM: '',
        R_ITEMKITTCODE: '',
        UNITSPERPACKAGEQUANTITY: null,
        ARTRADEDISCOUNTFLAG: 'Y',
        PACKAGESPERSHIPPINGUNITUOM: '',
        ARTERMSDISCOUNTFLAG: 'Y',
        PACKAGESPERSHIPPINGUNITQTY: null,
        SALEINCREMENTQUANTITY: 1,
        UNITVOLUMEUOM: '',
        MINIMUMSALESQUANTITY: null,
        UNITVOLUMEQUANTITY: null,
        USERDEFINEDCOMMENT: '',
        UNITAREAUOM: '',
        UNITAREAQUANTITY: null,
        UNITVALUEUOM: '',
        UNITVALUEQUANTITY: null,
        WEIGHTBASISFLAG: 'I',
        NETWEIGHTUOM: '',
        NETWEIGHTQUANTITY: null,
        GROSSWEIGHTUOM: '',
        R_PRODUCTCATEGORY: '',
        GROSSWEIGHTQUANTITY: null,
        VENDORITEMCODE: '',
        RECEIPTUOMDEFAULT: 'I',
        RECEIPTUOMMULTIPLE: 'I',
        RECEIPTUOMALTERNATIVE: '',
        RECEIPTPACKSIZE: '',
        SHIPMENTUOMDEFAULT: 'I',
        SHIPMENTUOMMULTIPLE: 'I',
        SHIPMENTUOMALTERNATIVE: 'F',
        SHIPMENTPACKSIZE: '',
        SHIPSELECTION: 'N',
        STACKHEIGHT: null,
        PALLETPATTERNROW: null,
        PALLETPATTERNCOLUMN: null,
        PALLETPATTERNHEIGHT: null,
        // Delphi binds this to a TDBArgosNumberCombo (numeric), and Layout.js declares it
        // "type": "number". An empty string persists as a non-NULL blank, which Delphi then
        // tries to render as a number - StrToFloat('') aborts its item form. NULL renders blank.
        PALLETSIZECODE: null,
        BOXCODE: '',
        HAZARDOUSFLAG: 'N',
        CAREINSTRUCTIONS: '',
        SPECIFICATIONCODE: '',
        ITEMSUPCCODE: '',
        BOMEXPLOSIONFLAG: 'N',
        MISCELLEANOUSFEEFLAG: null,
        STORAGELOCATIONTYPE: 'W',
        STORAGELOCATIONPRIORITYFLAG: '',
        SYSTEMCODE: '',
        ASSEMBLYCODE: '',
        PARTCODE: '',
        EMCOSTBUCKETNUMBER: null,
        TLFUELTAXFLAG: '',
        TLFUELTAXCODE: '',
        // Delphi stamps these three only for RecordType='R' (uIMM0008.PAS:1692) - a 'P' data
        // profile record is a template and carries no dates, so they stay null here.
        DATEINTRODUCED: isProfileDefaults ? null : new Date(),
        DATEAVAILABLE: isProfileDefaults ? null : new Date(),
        DATEEXPIRATION: null,
        STORAGEBILLINGSTARTDATE: isProfileDefaults ? null : new Date(),
        STORAGEBILLINGENDDATE: new Date(2999, 11, 31),
        ITEMSOURCEFLAG: 'M',
        REORDERMETHODFLAG: 'N',
        REORDERINVENTORYMINIMUMQTY: null,
        REORDERINVENTORYMAXIMUMQTY: null,
        REORDERMINIMUMDAYSONHAND: null,
        REORDERMAXIMUMDAYSONHAND: null,
        REORDERQUANTITYEOQCALCULATED: null,
        REORDERQUANTITYENTERED: null,
        REORDERQUANTITYORDERMULTIPLE: null,
        REORDERSAFETYQUANTITY: null,
        REORDERLEADTIME: null,
        COSTBASISMETHODFLAG: 'A',
        AVERAGECOST: null,
        STANDARDCOST: null,
        R_PRICETABLE: '',
        COREPRICE: null,
        MAXIMUMPRICELEVELFORDISCOUNT: null,
        // Defaults below mirror Delphi's qryIMItemAfterInsert (uIMM0008.PAS:1686), which
        // stamps them on every item it creates. Blanks are not equivalent: a fixed-width
        // char column stores '' as spaces, so the value is non-NULL and defeats the
        // IsNull guards Delphi relies on throughout its item form.
        ANNIVERSARYBILLINGFLAG: 'N',
        ANNIVERSARYBILLINGDATE: null,
        ANNIVERSARYBILLINGQUANTITY: null,
        WARRANTYFLAG: 'N',
        WARRANTYPERIODTYPEFLAG: '',
        WARRANTYMONTHS: null,
        WARRANTYMETERMILES: null,
        WARRANTYMETERHOURS: null,
        USERDEFINEDCODE_1: '',
        USERDEFINEDCODE_2: '',
        USERDEFINEDCODE_3: '',
        USERDEFINEDCODE_4: '',
        USERDEFINEDCODE_5: '',
        USERDEFINEDCODE_6: '',
        USERDEFINEDCODE_7: '',
        USERDEFINEDCODE_8: '',
        USERDEFINEDCODE_9: '',
        USERDEFINEDCODE_10: '',
        USERDEFINEDREFERENCE_1: '',
        USERDEFINEDREFERENCE_2: '',
        USERDEFINEDREFERENCE_3: '',
        USERDEFINEDREFERENCE_4: '',
        USERDEFINEDREFERENCE_5: '',
        USERDEFINEDREFERENCE_6: '',
        USERDEFINEDREFERENCE_7: '',
        USERDEFINEDREFERENCE_8: '',
        USERDEFINEDREFERENCE_9: '',
        USERDEFINEDREFERENCE_10: '',
        USERDEFINEDDATE_1: null,
        USERDEFINEDDATE_2: null,
        USERDEFINEDDATE_3: null,
        USERDEFINEDDATE_4: null,
        USERDEFINEDDATE_5: null,
        USERDEFINEDDATE_6: null,
        USERDEFINEDDATE_7: null,
        USERDEFINEDDATE_8: null,
        USERDEFINEDDATE_9: null,
        USERDEFINEDDATE_10: null,
        USERDEFINEDQUANTITY_1: null,
        USERDEFINEDQUANTITY_2: null,
        USERDEFINEDQUANTITY_3: null,
        USERDEFINEDQUANTITY_4: null,
        USERDEFINEDQUANTITY_5: null,
        USERDEFINEDQUANTITY_6: null,
        USERDEFINEDQUANTITY_7: null,
        USERDEFINEDQUANTITY_8: null,
        USERDEFINEDQUANTITY_9: null,
        USERDEFINEDQUANTITY_10: null,
        R_GLFUND: '',
        PROFILEGUID: '',
        LOCATIONCLASSFORWARDPICK: '',
        LOCATIONCLASSREPLENSHMENT: '',
        LOCATIONCLASSRESERVE: '',
        LOCATIONSUBCLASSFORWARDPICK: '',
        LOCATIONSUBCLASSREPLENSHMENT: '',
        LOCATIONSUBCLASSRESERVE: '',
        LOCATIONMAXUNITSFORWARDPICK: null,
        LOCATIONMINUNITSFORWARDPICK: null,
        R_LOCATIONPRIMARYREPLENSMENT: '',
        R_LOCATIONPRIMARYRESERVE: '',
        R_LOCATIONBACKUPFORWARDPICK: '',
        R_LOCATIONBACKUPREPLENSMENT: '',
        R_LOCATIONBACKUPRESERVE: '',
        LOCATIONMINUNITSREPLENISHMENT: null,
        LOCATIONMAXUNITSREPLENISHMENT: null,
        PALLETREFERENCE: '',
        R_HAZARDOUS: '',
        ON_HAND: 0,
        IN_ORDERED: 0,
        OUT_ORDERED: 0,
        IN_RECEIVING: 0,
        OUT_SHIPPED: 0,
        IN_BACKORDER: 0,
        OUT_BACKORDER: 0,
        IN_UNAVAILABLE: 0,
        OUT_UNAVAILABLE: 0,
        IN_FUTURE: 0,
        OUT_FUTURE: 0,
        AVAILABLE: 0,
        NETAVAILABLE: 0,
        R_RATESCHEDULE: '',
        POPUPMESSAGE: '',
        LASTCOST: null,
        INVENTORYQUANTITYSOURCE: 'I',
        R_BUYER: '',
        RATESOURCE: 'I',
        RATESELECTION: 'N',
        SIZE_1: null,
        SIZE_2: null,
        STORAGEBILLEDDATE_LAST: null,
        STORAGEBILLEDDATE_NEXT: null,
        MSDSFILENAME: '',
        R_ASSOCIATEITEM: '',
        ASSOCIATEDESC: '',
        PRICESOURCE: 'S',
        PRICEMETHOD: 'D',
        CALCMETHOD: 'M',
        PRICELEVELA: null,
        PRICELEVELB: null,
        PRICELEVELC: null,
        PRICELEVELD: null,
        PRICELEVELE: null,
        R_WARRANTYCODE: '',
        MANAGEMENTSOURCE: 'I',
        PRICEBASIS: null,
        R_FEES: '',
        SUBLOTUNIQUEFLAG: 'N',
        RFRECEIPTVALIDATION: 'N',
        RFSHIPMENTVALIDATION: 'N',
        INTRANSACTIONNUMBER: '',
        DATELASTRECEIPT: null,
        // Delphi's AfterInsert sets both to 1.0. The columns also carry DB defaults of ((1)), but
        // relying on those leaves the values absent from state after an insert - and updateItem posts
        // the whole formFields object, so a second Save would write NULL back over them.
        ACSTANDARDUNITFACTOR: 1,
        ACSTANDARDWEIGHTFACTOR: 1,
        ITEMPAYGROUP: '',
        R_PARTICIPANT: '',
        COMMISSIONBASIS: 'U',
        COMMISSIONAMOUNT: null,
        ROUNDINGMETHOD: 'C',
        // Delphi's AfterInsert value; DB default ((0.0001)) - see the note on the AC factors above.
        ROUNDINGFACTOR: 0.0001,
        ALTERNATESTANDARDCOST: null,
        ALTERNATEAVERAGECOST: null,
        ALTERNATELASTCOST: null,
        PREVSTORAGEBILLEDDATE_LAST: null,
        PREVSTORAGEBILLEDDATE_NEXT: null,
        RECURRINGSTORAGE: 'Y',
        WEBACCESSIBILITY: '',
        OMKITFLAG: 'N',
        PMKITFLAG: 'A',
        WARRANTYFLAG_SHIPMENT: 'N',
        WARRANTYMONTHS_SHIPMENT: null,
        CHECKMAXDAYS: '',
        MAXDAYS: null,
        CHECKLOTEXPIRATION: '',
        UPDATEUOMWEIGHT: 'N',
        AUTOMATICALLYUPDATEQUANTITY: 'N',
        LOCATIONAVAILABLEDEFAULT: '',
        LOCATIONREASONCODEDEFAULT: '',
        R_ITEMGROUP: '',
        ITEMSUBGROUP: '',
        ITEMMEMBER: '',
        CHECKRECEIPTDAYS: '',
        CHECKSHIPMENTDAYS: '',
        R_IMMANDATEDFEES: '',
        EXPDATEBASEDON: 'N',
        ADDTOEXPDATE: null,
        USERDEFINEDCODE_11: '',
        USERDEFINEDCODE_12: '',
        USERDEFINEDCODE_13: '',
        USERDEFINEDCODE_14: '',
        USERDEFINEDCODE_15: '',
        USERDEFINEDCODE_16: '',
        USERDEFINEDCODE_17: '',
        USERDEFINEDCODE_18: '',
        USERDEFINEDCODE_19: '',
        USERDEFINEDCODE_20: '',
        USERDEFINEDDATE_11: null,
        USERDEFINEDDATE_12: null,
        USERDEFINEDDATE_13: null,
        USERDEFINEDDATE_14: null,
        USERDEFINEDDATE_15: null,
        USERDEFINEDDATE_16: null,
        USERDEFINEDDATE_17: null,
        USERDEFINEDDATE_18: null,
        USERDEFINEDDATE_19: null,
        USERDEFINEDDATE_20: null,
        USERDEFINEDQUANTITY_11: null,
        USERDEFINEDQUANTITY_12: null,
        USERDEFINEDQUANTITY_13: null,
        USERDEFINEDQUANTITY_14: null,
        USERDEFINEDQUANTITY_15: null,
        USERDEFINEDQUANTITY_16: null,
        USERDEFINEDQUANTITY_17: null,
        USERDEFINEDQUANTITY_18: null,
        USERDEFINEDQUANTITY_19: null,
        USERDEFINEDQUANTITY_20: null,
        USERDEFINEDREFERENCE_11: '',
        USERDEFINEDREFERENCE_12: '',
        USERDEFINEDREFERENCE_13: '',
        USERDEFINEDREFERENCE_14: '',
        USERDEFINEDREFERENCE_15: '',
        USERDEFINEDREFERENCE_16: '',
        USERDEFINEDREFERENCE_17: '',
        USERDEFINEDREFERENCE_18: '',
        USERDEFINEDREFERENCE_19: '',
        USERDEFINEDREFERENCE_20: '',
        WMCONSIGNEEEXPDAYS: 'N',
        REFERENCE_1: '',
        REFERENCE_2: '',
        REFERENCE_3: '',
        REFERENCE_4: '',
        REFERENCE_5: '',
        USERDEFINEDCOMMENT_2: '',
        OVERSELLPERCENTAGE: null,
        SALEMAXQUANTITY: null,
        R_CONTAINERCODE: '',
        RECORD: '',
        RECEIPTPUTONHOLD: 'N',
        HOLDREASONCODE: null,
        HOLDDAYSCOUNT: null,        
        INVENTORYUNITNOTUSED:1,
        GROSSMINUSNET:null,
    };

    const history = useHistory();
    var accessToken = props.oidc.user.access_token;


    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [formFields, setformFields] = useState(initialFormFields);

    // primaryFormLoad can fire more than once - FormField invokes onFormLoad from the `finally` of
    // its schema fetch - so the one-time profile seed needs a guard that survives re-renders.
    const hasSeededProfileDefaults = useRef(false);

    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const position = { of: '#accordion-containe2' };
    const formRefs = useRef({});
    const getFieldInstance = (name) => {
        const field = formRefs.current?.[name];
        const instance = typeof field?.instance === 'function' ? field.instance() : undefined;
        return typeof instance?.option === 'function' ? instance : undefined;
    };
    const handleFormSubmit = async (e) => {
        setLoadPanelVisible(true);
        setIsFormSubmitted(true);
        try {
            e.preventDefault();
            if (formFields.ROWID == "00000000-0000-0000-0000-000000000000") {
                await insertItem();
            }
            else {
                await updateItem();
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };

    const insertItem = async () => {
        try {
            const url = "wm/Item/InsertItem";

            let fields = formFields;
            fields.DATEINTRODUCED = GetFormatedDateWithTime(formFields.DATEINTRODUCED);
            fields.DATEAVAILABLE = GetFormatedDateWithTime(formFields.DATEAVAILABLE);
            fields.DATEEXPIRATION = GetFormatedDateWithTime(formFields.DATEEXPIRATION);
            fields.STORAGEBILLINGSTARTDATE = GetFormatedDateWithTime(formFields.STORAGEBILLINGSTARTDATE);
            fields.STORAGEBILLINGENDDATE = GetFormatedDateWithTime(formFields.STORAGEBILLINGENDDATE);
            fields.ANNIVERSARYBILLINGDATE = GetFormatedDateWithTime(formFields.ANNIVERSARYBILLINGDATE);
            fields.USERDEFINEDDATE_1 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_1);
            fields.USERDEFINEDDATE_2 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_2);
            fields.USERDEFINEDDATE_3 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_3);
            fields.USERDEFINEDDATE_4 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_4);
            fields.USERDEFINEDDATE_5 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_5);
            fields.USERDEFINEDDATE_6 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_6);
            fields.USERDEFINEDDATE_7 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_7);
            fields.USERDEFINEDDATE_8 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_8);
            fields.USERDEFINEDDATE_9 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_9);
            fields.USERDEFINEDDATE_10 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_10);
            fields.STORAGEBILLEDDATE_LAST = GetFormatedDateWithTime(formFields.STORAGEBILLEDDATE_LAST);
            fields.STORAGEBILLEDDATE_NEXT = GetFormatedDateWithTime(formFields.STORAGEBILLEDDATE_NEXT);
            fields.DATELASTRECEIPT = GetFormatedDateWithTime(formFields.DATELASTRECEIPT);
            fields.PREVSTORAGEBILLEDDATE_LAST = GetFormatedDateWithTime(formFields.PREVSTORAGEBILLEDDATE_LAST);
            fields.PREVSTORAGEBILLEDDATE_NEXT = GetFormatedDateWithTime(formFields.PREVSTORAGEBILLEDDATE_NEXT);

            const response = await axios.post(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    'Content-Type': 'application/json',
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (!response.data.ERRORS.length > 0) {
                setformFields(prevFields => ({
                    ...prevFields,
                    ROWID: response.data.ROWID,
                    RECORD: response.data.RECORD
                }));
                notify(
                    {
                        message: "Item Created",
                        width: 100,
                    },
                    'success',
                    3000,
                );
                setIsFormSubmitted(false);
            } 
        } catch (error) {
            console.error('Error submitting form:', error);
            if(error.response.data.ERRORS && error.response.data.ERRORS.length > 0)
            {
                const errorHtml = error.response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();
            }
            else
            {
                notify(
                    {
                        message: "Could not create item. An error occurred",
                        width: 100,
                    },
                    'error',
                    3000,
                );
            }
            
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };
    const updateItem = async () => {
        try {
            const url = "wm/Item/UpdateItem";
            let fields = formFields;
            fields.LASTUPDATEDATETIME = null;
            fields.DATEINTRODUCED = GetFormatedDateWithTime(formFields.DATEINTRODUCED);
            fields.DATEAVAILABLE = GetFormatedDateWithTime(formFields.DATEAVAILABLE);
            fields.DATEEXPIRATION = GetFormatedDateWithTime(formFields.DATEEXPIRATION);
            fields.STORAGEBILLINGSTARTDATE = GetFormatedDateWithTime(formFields.STORAGEBILLINGSTARTDATE);
            fields.STORAGEBILLINGENDDATE = GetFormatedDateWithTime(formFields.STORAGEBILLINGENDDATE);
            fields.ANNIVERSARYBILLINGDATE = GetFormatedDateWithTime(formFields.ANNIVERSARYBILLINGDATE);
            fields.USERDEFINEDDATE_1 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_1);
            fields.USERDEFINEDDATE_2 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_2);
            fields.USERDEFINEDDATE_3 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_3);
            fields.USERDEFINEDDATE_4 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_4);
            fields.USERDEFINEDDATE_5 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_5);
            fields.USERDEFINEDDATE_6 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_6);
            fields.USERDEFINEDDATE_7 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_7);
            fields.USERDEFINEDDATE_8 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_8);
            fields.USERDEFINEDDATE_9 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_9);
            fields.USERDEFINEDDATE_10 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_10);
            fields.STORAGEBILLEDDATE_LAST = GetFormatedDateWithTime(formFields.STORAGEBILLEDDATE_LAST);
            fields.STORAGEBILLEDDATE_NEXT = GetFormatedDateWithTime(formFields.STORAGEBILLEDDATE_NEXT);
            fields.DATELASTRECEIPT = GetFormatedDateWithTime(formFields.DATELASTRECEIPT);
            fields.PREVSTORAGEBILLEDDATE_LAST = GetFormatedDateWithTime(formFields.PREVSTORAGEBILLEDDATE_LAST);
            fields.PREVSTORAGEBILLEDDATE_NEXT = GetFormatedDateWithTime(formFields.PREVSTORAGEBILLEDDATE_NEXT);
            fields.USERDEFINEDDATE_11 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_11);
            fields.USERDEFINEDDATE_12 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_12);
            fields.USERDEFINEDDATE_13 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_13);
            fields.USERDEFINEDDATE_14 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_14);
            fields.USERDEFINEDDATE_15 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_15);
            fields.USERDEFINEDDATE_16 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_16);
            fields.USERDEFINEDDATE_17 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_17);
            fields.USERDEFINEDDATE_18 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_18);
            fields.USERDEFINEDDATE_19 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_19);
            fields.USERDEFINEDDATE_20 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_20);

            const response = await axios.put(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (!response.data  || !response.data.ERRORS.length > 0)  {
                notify(
                    {
                        message: "Item Updated",
                        width: 100,
                    },
                    'success',
                    3000,
                );
                setIsFormSubmitted(false);
            } 
            

        } catch (error) {
            console.error('Error submitting form:', error);
            
            if(error.response.data.ERRORS && error.response.data.ERRORS.length > 0)
            {
                var hasWarning = false;
                var hasConfirmation = false;
                var errorMessage = "";
                var errorsArray = [];

                for (let i = 0; i < error.response.data.ERRORS.length; i++) {
                    
                    if (error.response.data.ERRORS[i].startsWith("[ItemTypeWarning]"))
                    {
                        hasWarning = true;
                        errorMessage = error.response.data.ERRORS[i];
                        errorMessage = errorMessage.replace('[ItemTypeWarning]','');
                        errorMessage = errorMessage.replace(/(?:\r\n|\r|\n)/g, '<br>');
                    }
                    else if (error.response.data.ERRORS[i].startsWith("[ItemTypeConfirmation]"))
                    {
                        hasConfirmation = true;
                        errorMessage = error.response.data.ERRORS[i];
                        errorMessage = errorMessage.replace('[ItemTypeConfirmation]','');
                        errorMessage = errorMessage.replace(/(?:\r\n|\r|\n)/g, '<br>');
                    }
                    else
                    {
                        errorsArray.push(error.response.data.ERRORS[i]);
                    }
                }
                
                if(errorsArray.length > 0)
                {
                    const errorHtml = errorsArray.map(err => `<div>${err}</div>`).join('');
                    custom({
                        title: "Errors",
                        messageHtml: errorHtml,
                        buttons: [{ text: "OK", onClick: () => { } }]
                    }).show();
                }
                else
                {
                    if (hasWarning)
                    {
                        alert(errorMessage, "Warning");
                        setformFields(prevFields => ({
                            ...prevFields,
                            ITEMTYPE: perviousItemType
                        }));

                    }
                    else if (hasConfirmation)
                    {

                    }
                }
            }
            else
            {
                notify(
                    {
                        message: "Could not create item. An error occurred",
                        width: 100,
                    },
                    'error',
                    3000,
                );
            }

            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };

    const primaryFormLookupsLoad =() => {
        primaryFormLoad();
        additionalFormLoad();
        handleUOMFormLoad();
        statusFormLookupsLoad();
        kitFormLookupsLoad();
        
    }

    const primaryFormLoad =()=>{
        
        loadLookupFromStaticData(formRefs,"ITEMTYPE",[{id:'I',name:"Item"},{id:'L',name:"Item/Lot"},{id:'S',name:"Item/Lot/Sublot"},{id:'U',name:"Item/Lot/Sublot/Unit"}]);
        loadLookupFromStaticData(formRefs,"STATUS",[{id:'A',name:"Active"},{id:'I',name:"Inactive"}]);

        if (formRefs.current['RECORD']){
            formRefs.current['RECORD'].instance().option('disabled', true);
        }

        const { isProfileDefaults: isProfileDefaultsRoute, profileRowId, profileCode: seedProfileCode } = readProfileDefaults();

        if (isProfileDefaultsRoute) {
            // Seed only when creating. props.id is the create/edit discriminator - relying on
            // RProfile being absent on the edit route was too fragile: the moment that route also
            // carried RProfile, the seed overwrote the record being edited.
            if (!props.id && !hasSeededProfileDefaults.current && profileRowId) {
                SeedProfileDefaultsItem(profileRowId, seedProfileCode);
                hasSeededProfileDefaults.current = true;
            }

            DisableProfileField();
            ShowProfileCode(seedProfileCode);
        }
    }

    const ShowProfileCode = (profileCode) => {
        if (!profileCode) return;

        const instance = getFieldInstance('R_PROFILE');
        // Only when empty: primaryFormLoad can fire more than once, and a programmatic write raises
        // onValueChanged, which restarts DynamicFromLookup's own resolve for an already-correct value.
        if (instance && !instance.option('value')) instance.option('value', profileCode);
    };

    const additionalFormLoad =()=>{
        loadLookupFromStaticData(formRefs,"RATESOURCE",[{id:'I',name:"Item"},{id:'L',name:"Lot"}]);
        loadLookupFromStaticData(formRefs,"RATESELECTION",[{id:'N',name:"Show All Rate Schedules"},{id:'C',name:"Filter By Customer"},{id:'L',name:"Filter By Customer/Class"},{id:'S',name:"Filter By Customer/Class/Sub Class"},{id:'U',name:"Filter By Class"},{id:'V',name:"Filter By Sub Class"}]);

        if (formRefs.current['PREVSTORAGEBILLEDDATE_LAST']){
            formRefs.current['PREVSTORAGEBILLEDDATE_LAST'].instance().option('disabled', true);
        }

        if (formRefs.current['PREVSTORAGEBILLEDDATE_NEXT']){
            formRefs.current['PREVSTORAGEBILLEDDATE_NEXT'].instance().option('disabled', true);
        }
        loadLookupFromStaticData(formRefs,"RECURRINGSTORAGE",[{id:'Y',name:"Yes, Always Generate Recurring Storage Charges"},{id:'N',name:"No, Never Generate Recurring Storage Charges"}]);
        loadLookupFromStaticData(formRefs,"MANAGEMENTSOURCE",[{id:'I',name:"Item"},{id:'L',name:"Lot"}]);
        loadLookupFromStaticData(formRefs,"RECEIPTPUTONHOLD",[{id:'N',name:"No"},{id:'Y',name:"Yes"}]);
        loadLookupFromStaticData(formRefs,"LOCATIONAVAILABLEDEFAULT",[{id:'Y',name:"Yes, Available"},{id:'N',name:"No, Not Available"}]);

        //loadRateScheduleLookupFromDataSource();
        if (formRefs.current["R_RATESCHEDULE"])
        {
            if(formFields.R_RATESCHEDULE)
            {
                formRefs.current["R_RATESCHEDULE"].instance().option('value', formFields.R_RATESCHEDULE);
            }

            if (formFields.RATESOURCE && formFields.RATESOURCE == "L")
            {
                formRefs.current['R_RATESCHEDULE'].instance().option('disabled', true);
            }
        }

    }
    
    const loadLookupFromStaticData = (formRefs,name,dataSource) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'id');
            formRefs.current[name].instance().option('displayExpr', 'name');
            if(formFields[name])
                formRefs.current[name].instance().option('value', formFields[name]);
        }

    };

    const loadRateScheduleLookupFromDataSource = () => {
        if (formRefs.current["R_RATESCHEDULE"]) 
        {

            var dataSource = new DataSource({
                store: new createStore({
                    key: 'id',
                    loadUrl: `${window._env_.REACT_APP_APIS}/${data.WMLookup.WMRateSchedule}`,
                    loadParams:{
                        scheduleType: function ()
                        {
                            return 'I';
                        },
                        customerRowId: function ()
                        {
                            if (currentRATESELECTION == "C" || currentRATESELECTION == "L" || currentRATESELECTION == "S")
                            {
                                return currentR_IDENTITY;
                            }
                            return null;
                        },
                        classCode: function ()
                        {
                            if (currentRATESELECTION == "L" || currentRATESELECTION == "S" || currentRATESELECTION == "U")
                            {
                                return currentCLASSCODE;
                            }

                            return "[NONE]";
                        },
                        subClassCode: function ()
                        {
                            if (currentRATESELECTION == "S" || currentRATESELECTION == "V")
                            {
                                return currentSUBCLASSCODE;
                            }
                            
                                return "[NONE]";
                        },
                        status: function ()
                        {
                            if(profile != null && profile.Rateschedulefilter && profile.Rateschedulefilter == "A")
                            {
                                return "A";
                            }
                            
                            return "[NONE]";
                        }
                        },
                    onBeforeSend: function (method, ajaxOptions) {
                        ajaxOptions.headers = {
                            Authorization: `Bearer ${accessToken}`
                        };
                    }
                }),
                sort: [{ selector: "name", desc: false }],
                paginate: true,
                pageSize: 100
            });
                
            formRefs.current["R_RATESCHEDULE"].instance().option('dataSource', dataSource);
            formRefs.current["R_RATESCHEDULE"].instance().option('valueExpr', "id");
            formRefs.current["R_RATESCHEDULE"].instance().option('displayExpr', "name");
            
        }
    };

    const handleReset = () => {

        // props.id is null on the add route even after a save - the URL never changes - so fall back
        // to the key the insert response put in state, or Reset would discard the saved record.
        const savedRowId = formFields.ROWID && formFields.ROWID !== EMPTY_GUID ? formFields.ROWID : null;
        var rowid = props.id || savedRowId;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
        else 
        {
            skipDataLoading = true;
            setformFields(initialFormFields);
            skipDataLoading = false;
            EnableControlsForNewRecord();

            // The profile owns this record, so a reset must not clear its code or unlock the field.
            // Re-seeding after the blank works because SeedProfileDefaultsItem uses a functional
            // update: React applies it to the result of the reset in the same batch. Disable last -
            // EnableControlsForNewRecord above re-enables R_PROFILE unconditionally.
            const { isProfileDefaults: isProfileDefaultsRoute, profileRowId, profileCode } = readProfileDefaults();
            if (isProfileDefaultsRoute) {
                if (profileRowId) {
                    SeedProfileDefaultsItem(profileRowId, profileCode);
                }

                DisableProfileField();
                ShowProfileCode(profileCode);
            }
        }

    };

    const DeleteClick = async () => {
        let result = confirm("<i>Are your sure you want to delete this record?</i>", "Delete");
        result.then(async (dialogResult) => {
            if (dialogResult) {
                setLoadPanelVisible(true);
                try 
                {
                    const response = await axios.post(`${window._env_.REACT_APP_APIS}/${'wm/Item/DeleteItem'}`, formFields.ROWID, {
                        headers: {
                            'Content-Type': 'application/json',
                            access_token: accessToken,
                            Authorization: `Bearer ${accessToken}`
                        },
                    });
                    if (!response.data.ERRORS.length > 0) {
                        notify(
                            {
                                message: "Item Deleted",
                                width: 100,
                            },
                            'success',
                            3000,
                        );
                        setLoadPanelVisible(false);
                        goBack();
                    } 
                    else 
                    {
                        setLoadPanelVisible(false);
                        const errorHtml = response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                        custom({
                            title: "Errors",
                            messageHtml: errorHtml,
                            buttons: [{ text: "OK", onClick: () => { } }]
                        }).show();
                    }
                } 
                catch (error) 
                {
                    
                    setLoadPanelVisible(false);

                    if(error.response.data.ERRORS && error.response.data.ERRORS.length > 0)
                    {
                        const errorHtml = error.response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                        custom({
                            title: "Errors",
                            messageHtml: errorHtml,
                            buttons: [{ text: "OK", onClick: () => { } }]
                        }).show();
                    }
                    else
                    {
                        notify(
                            {
                                message: "Could not delete item. An error occurred",
                                width: 100,
                            },
                            'error',
                            3000,
                        );
                    }
                } 
            }
        })
    }

    const addNewRecordClick = () => {
        setIsFormSubmitted(false);
        skipDataLoading = true;
        setformFields(initialFormFields);
        skipDataLoading = false;
        history.push(ItemDataEntryRoutes.Create);
        EnableControlsForNewRecord();
    }

    const GetHeaderInfoById = (id) => {
        try {
            setLoadPanelVisible(true);
            axios.get(`${window._env_.REACT_APP_APIS}/wm/item/GetItemDataByRowId?rowid=${id}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                setTimeout(hideLoadPanel, 1000);
                const responseData = res.data.Item1;
                profile = res.data.Item2;

                if (responseData.ROWID) {
                    skipDataLoading = true;
                    responseData.INVENTORYUNITNOTUSED=1;
                    setformFields(responseData);
                    skipDataLoading = false;
                    if(responseData.REORDERMETHODFLAG == "N"){
                        reOrderMethodFlag = true;
                    } 
                    if (formRefs.current["R_PROFILE"]) {
                        formRefs.current["R_PROFILE"].instance().option('disabled', true);
                    }
                    if (formRefs.current["R_IDENTITY"] && responseData.DISABLECUSTOMERLOOKUP) {
                        formRefs.current["R_IDENTITY"].instance().option('disabled', true);
                    }
                    if (formRefs.current["PHYSICALCOUNTCODE"]) {
                        formRefs.current["PHYSICALCOUNTCODE"].instance().option('disabled', true);
                    }

                    currentR_IDENTITY = responseData.R_IDENTITY;
                    currentRATESELECTION = responseData.RATESELECTION;
                    currentCLASSCODE = responseData.CLASSCODE;
                    currentSUBCLASSCODE = responseData.SUBCLASSCODE;

                }
                else {
                    console.error('Failed to get item data');
                }
            }).catch((error) => {
                // The surrounding try/catch only sees synchronous throws, so without this a rejected
                // request left the load panel up for good - hideLoadPanel is only reached from .then.
                console.error('Error failed to get item data:', error);
                setTimeout(hideLoadPanel, 1000);
            });


        } catch (error) {
            console.error('Error failed to get item data:', error);
            setTimeout(hideLoadPanel, 1000);
        }
    };

    /**
     * Seeds a blank profile-defaults record when the profile has none yet - Delphi
     * uWMD0000.SetParameters, which inserts the 'P' row if its query comes back empty.
     *
     * Only the create path needs this. When a 'P' record already exists the Item Data Profile screen
     * navigates with its real item ROWID, so this form loads it through the ordinary
     * GetHeaderInfoById like any other item - props.id is always an item id, never a profile id.
     *
     * Both values arrive in the URL, so there is no lookup here: RProfile to stamp on the new row,
     * profileCode for the read-only Profile field.
     */
    // Delphi: ab_EnableControl(edtP_PROFILE, False) - the profile owns this record, so its code is
    // not editable here. Kept separate from the seed because the two need different things: the seed
    // needs the URL params, this needs the widget to exist. formRefs is a ref, so re-running it on
    // every form load is safe and covers the load where the widget mounted after the state was set.
    const DisableProfileField = () => {
        if (formRefs.current["R_PROFILE"]) {
            formRefs.current["R_PROFILE"].instance().option('disabled', true);
        }
    };

    const SeedProfileDefaultsItem = (profileRowId, profileCode) => {
        skipDataLoading = true;
        // Merge into current state rather than spreading initialFormFields: primaryFormLoad can fire
        // more than once, and replacing the whole object discarded everything the earlier load cycle
        // had already put in the form.
        setformFields(prev => ({
            ...prev,
            RECORDTYPE: RECORD_TYPE.PROFILE_DEFAULTS,
            R_PROFILE: profileRowId,
            PROFILECODE: profileCode || '',
            // Delphi stamps these only for RecordType='R' (uIMM0008.PAS:1692); a 'P' template shows
            // them blank. Cleared explicitly rather than relying on initialFormFields, which is only
            // the useState seed - a reused form instance carries the previous mount's dates through
            // the ...prev merge above.
            DATEINTRODUCED: null,
            DATEAVAILABLE: null,
            STORAGEBILLINGSTARTDATE: null,
        }));
        skipDataLoading = false;
    };

    useEffect(() => {
        var rowid = props.id;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
            return;
        }
    }, [props.id]);
     useEffect(() => {
       formFieldsRef.current = formFields;
     }, [formFields]);
    const goBack = () => {
        if (isProfileDefaults) {
            // Opened from the Item Data Profile screen, so go back there rather than to the item
            // listing - Delphi returns to the calling form (ab_ExitProgram).
            //
            // Push the profile's Edit route explicitly instead of history.goBack(): the profile form
            // stays on its Create URL after a save (it only updates ROWID in state), so goBack()
            // remounted a blank Add Profile screen and the saved record appeared lost.
            // Take the key from the URL, which the Item Data Profile screen now stamps on both of
            // its Item Defaults routes. formFields.R_PROFILE is only a fallback: it was observed
            // holding the item's own rowid, which pushed the profile screen at a 404.
            const { profileRowId } = readProfileDefaults();
            const target = profileRowId || formFields.R_PROFILE;
            if (target) {
                history.push(`${ItemDataProfileRoutes.Edit}?rowid=${target}`);
                return;
            }

            history.push(ItemDataProfileRoutes.List);
            return;
        }

        history.push(ItemDataEntryRoutes.List);
    };

    const EnableControlsForNewRecord = () => {
        
        if (formRefs.current["R_PROFILE"]) {
            formRefs.current["R_PROFILE"].instance().option('disabled', false);
        }

        if (formRefs.current["R_IDENTITY"]) {
            formRefs.current["R_IDENTITY"].instance().option('disabled', false);
        }

        if (formRefs.current["PHYSICALCOUNTCODE"]) {
            formRefs.current["PHYSICALCOUNTCODE"].instance().option('disabled', false);
        }
    }

    const GetItemDataFromProfile = async (profileId) => {
        if (profileId === null)
            return;
        setLoadPanelVisible(true);
        try {
            const response = await axios.get(`${window._env_.REACT_APP_APIS}/${data.Item.GetItemDataByProfileRowId}?rowid=${profileId}`, {
                method: 'GET',
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });

            if (response.hasOwnProperty("data") && response.data != null && response.data != undefined && response.data != "") {
                var responseData = response.data.Item1;
                profile = response.data.Item2;

                if (responseData) 
                {
                    responseData.ROWID = '00000000-0000-0000-0000-000000000000';
                    responseData.RECORD = '';
                    responseData.CREATIONDATETIME = null;
                    responseData.LASTUPDATEDATETIME = null;
                    responseData.CREATIONUSERID =  '';
                    responseData.LASTUPDATEUSERID =  '';
                    responseData.COMPANYID =  '';
                    responseData.MODULE =  'WM';
                    responseData.RECORDTYPE =  RECORD_TYPE.REAL;
                    responseData.ON_HAND = 0;
                    responseData.IN_ORDERED = 0;
                    responseData.OUT_ORDERED = 0;
                    responseData.IN_RECEIVING = 0;
                    responseData.OUT_SHIPPED = 0;
                    responseData.IN_BACKORDER = 0;
                    responseData.OUT_BACKORDER = 0;
                    responseData.IN_UNAVAILABLE = 0;
                    responseData.OUT_UNAVAILABLE = 0;
                    responseData.IN_FUTURE = 0;
                    responseData.OUT_FUTURE = 0;
                    responseData.AVAILABLE = 0;
                    responseData.NETAVAILABLE = 0;
                   
                    // if customer has been entered, assume the user has already entered some information
                    // so only overwrite a field with the default value if the field is null}
                    // if customer has not been enterd then assign each field value of item profile to current item record}
                    if(formFields.R_IDENTITY != null && formFields.R_IDENTITY != "")
                    {
                        for (const key in formFields) 
                        {
                            if (formFields[key] != null &&  formFields[key] != '')
                            {
                                
                                responseData[key] = formFields[key];
                            }
                        }
                    }

                    responseData.DATEINTRODUCED =  new Date();
                    responseData.DATEAVAILABLE = new Date();
                    responseData.STORAGEBILLINGSTARTDATE = new Date();
                    responseData.STORAGEBILLINGENDDATE = new Date(2999, 11, 31);
                    responseData.INVENTORYUNITNOTUSED=1;
                    setformFields(responseData);

                    currentR_IDENTITY = responseData.R_IDENTITY;
                    currentRATESELECTION = responseData.RATESELECTION;
                    currentCLASSCODE = responseData.CLASSCODE;
                    currentSUBCLASSCODE = responseData.SUBCLASSCODE;
                    
                }
            }
            else {
                console.error('Failed to get item profile data');
            }
        } catch (error) {
            console.error('Error fetching item profile data:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };

    const handleFieldChange = useCallback((name, value, e) => {
       let currentFormFields=formFieldsRef.current;

        // uWMD0000 line 1042: "no need to populate from profile when editing item code data profile"
        // - the defaults record must not have the defaults copied onto itself.
        if (name == "R_PROFILE" && !skipDataLoading && !props.id && !readProfileDefaults().isProfileDefaults) {
            GetItemDataFromProfile(value);
        }

        if (name == "ITEMTYPE" && !skipDataLoading) {
            perviousItemType = e.previousValue;
        }

        if (name == "RATESOURCE" && !skipDataLoading) {
            if (value == "L")
            {
                if (formRefs.current['R_RATESCHEDULE'])
                {
                    formRefs.current['R_RATESCHEDULE'].instance().option('disabled', true);
                }

                setformFields(prevState => ({
                    ...prevState,
                    R_RATESCHEDULE: null,
                }));

            }
            else
            {
                if (formRefs.current['R_RATESCHEDULE'])
                {
                    formRefs.current['R_RATESCHEDULE'].instance().option('disabled', false);
                }
            }

        }

        if (name == "RATESELECTION" && !skipDataLoading) {
            currentRATESELECTION = value;
            //loadRateScheduleLookupFromDataSource();
            setformFields(prevState => ({
                ...prevState,
                R_RATESCHEDULE: null,
            }));
        }

        if (name == "R_IDENTITY" && !skipDataLoading) {
            currentR_IDENTITY = value;
            //loadRateScheduleLookupFromDataSource();
        }

        if (name == "CLASSCODE" && !skipDataLoading) {
            currentCLASSCODE = value;
            //loadRateScheduleLookupFromDataSource();
        }

        if (name == "SUBCLASSCODE" && !skipDataLoading) {
            currentSUBCLASSCODE = value;
            //loadRateScheduleLookupFromDataSource();
        }


        
        if (name == "GROSSMINUSNET") 
        {
            let calculatedValue= currentFormFields['NETWEIGHTQUANTITY']+value;
            const grossWeigthQuantityInstancce = getFieldInstance("GROSSWEIGHTQUANTITY");
            if (grossWeigthQuantityInstancce)
                grossWeigthQuantityInstancce.option('value',calculatedValue);
        }
        if (name == "NETWEIGHTQUANTITY") 
        {
            let calculatedValue= currentFormFields['GROSSMINUSNET']+value;
            if (formRefs.current['GROSSWEIGHTQUANTITY'])
                formRefs.current['GROSSWEIGHTQUANTITY'].instance().option('value',calculatedValue);
        }
        let itemType = currentFormFields['ITEMTYPE'];
        
        if (name === "INVENTORYQUANTITYSOURCE") 
        {
            if (itemType < value) {
                setformFields(prevState => ({
                    ...prevState,
                    [name]: e.previousValue,
                }));
                alert('UOM Base Flag Must Be Less Then Or Equal To Item Type', 'Error');
            }
        }
        
        if (name === "WEIGHTBASISFLAG") 
        {
            if ( itemType < value) {
                setformFields(prevState => ({
                    ...prevState,
                    [name]: e.previousValue,
                }));
                alert('UOM Base Flag Must Be Less Then Or Equal To Item Type', 'Error');
            }
        }
    });

   const handleUOMFormLoad = useCallback(() => {
        loadLookupFromStaticData(formRefs,"INVENTORYQUANTITYSOURCE",[{id:'I',name:"Item"},{id:'L',name:"Lot"},{id:'S',name:"Sublot"}]);
        loadLookupFromStaticData(formRefs,"WEIGHTBASISFLAG",[{id:'I',name:"Item"},{id:'L',name:"Lot"},{id:'S',name:"Sublot"},{id:'U',name:"Unit"}]);
        loadLookupFromStaticData(formRefs,"RECEIPTUOMDEFAULT",[{id:'I',name:"Inventory Unit"},{id:'P',name:"Pieces"},{id:'P',name:"Packages (eg. Pallets)"},{id:'H',name:"Shipment (eg. Container)"}]);
        loadLookupFromStaticData(formRefs,"SHIPMENTUOMDEFAULT",[{id:'I',name:"Inventory Unit"},{id:'P',name:"Pieces"},{id:'K',name:"Packages (eg. Pallets)"},{id:'H',name:"Shipment (eg. Container)"}]);
        loadLookupFromStaticData(formRefs,"RFRECEIPTVALIDATION",[{id:'Y',name:"EDI import to insert Serial # records for valdation by RF program"},{id:'N',name:"EDI import to gonre Serial # records or Serial #s do not exist"}]);
        loadLookupFromStaticData(formRefs,"RFSHIPMENTVALIDATION",[{id:'Y',name:"EDI import to insert Serial # records for valdation by RF program"},{id:'N',name:"EDI import to gonre Serial # records or Serial #s do not exist"}]);
        let calculatedValue= formFields['GROSSWEIGHTQUANTITY']- formFields['NETWEIGHTQUANTITY'];
        if(formRefs.current['GROSSMINUSNET'])
        {
            formRefs.current['GROSSMINUSNET'].instance().option('value',calculatedValue);
        }

        if(formRefs.current['INVENTORYUNITNOTUSED'])
        {
            formRefs.current['INVENTORYUNITNOTUSED'].instance().option('value',1);
        }
    });

    // Status Tab start
    const statusFormLookupsLoad =() => {
        statusFormLoad();
    }

    const statusFormLoad=()=>{
        loadLookupFromStaticData(formRefs,"EXPDATEBASEDON",[{id:'N',name:"None"},{id:'A',name:"Receive/Ship date of Receipt"},{id:'B',name:"Lot Code as Truncated JD of Receipt"},{id:'C',name:"Lot Code as Modified JD of Receipt"},{id:'D',name:"Lot Code as Julian Day of Receipt"}]);
        loadLookupFromStaticData(formRefs,"REORDERMETHODFLAG",[{id:'F',name:"By Fixed Date"},{id:'N',name:"Not Applicable"},{id:'M',name:"Based on Minimum Quantity"},{id:'D',name:"Based on Minimum Days"}]);
        loadLookupFromStaticData(formRefs,"WARRANTYFLAG",[{id:'N',name:"Not Applicable"},{id:'I',name:"Use Item Expiration Date"},{id:'L',name:"Use Lot Expiration Date"},{id:'S',name:"Use Sublot Expiration Date"}]);
        loadLookupFromStaticData(formRefs,"WARRANTYFLAG_SHIPMENT",[{id:'N',name:"Not Applicable"},{id:'I',name:"Use Item Expiration Date"},{id:'L',name:"Use Lot Expiration Date"},{id:'S',name:"Use Sublot Expiration Date"}]);
        loadLookupFromStaticData(formRefs,"CHECKRECEIPTDAYS",[{id:'1',name:"No expiration days checking"},{id:'2',name:"Check days and allow to continue"},{id:'3',name:"Check days and do not allow to continue"}]);
        loadLookupFromStaticData(formRefs,"CHECKSHIPMENTDAYS",[{id:'1',name:"No expiration days checking"},{id:'2',name:"Check days and allow to continue"},{id:'3',name:"Check days and do not allow to continue"}]);
        loadLookupFromStaticData(formRefs,"CHECKMAXDAYS",[{id:'1',name:"No"},{id:'2',name:"Yes, check but allow override"},{id:'3',name:"Yes, check but never allow override"}]);
        loadLookupFromStaticData(formRefs,"WMCONSIGNEEEXPDAYS",[{id:'N',name:"Do Not Adjust Expiration Days by Consignee"},{id:'Y',name:"Adjust Expiration Days by Consignee"}]);
        loadLookupFromStaticData(formRefs,"CHECKLOTEXPIRATION",[{id:'N',name:"No"},{id:'Y',name:"Yes"}]);
        if (formFields.ROWID == "00000000-0000-0000-0000-000000000000" || reOrderMethodFlag == true) {
             if (formRefs.current['REORDERINVENTORYMINIMUMQTY'])
                formRefs.current['REORDERINVENTORYMINIMUMQTY'].instance().option('disabled', true);
            if (formRefs.current['REORDERINVENTORYMAXIMUMQTY'])
                formRefs.current['REORDERINVENTORYMAXIMUMQTY'].instance().option('disabled', true);
            if (formRefs.current['REORDERMINIMUMDAYSONHAND'])
                formRefs.current['REORDERMINIMUMDAYSONHAND'].instance().option('disabled', true);
            if (formRefs.current['REORDERMAXIMUMDAYSONHAND'])
                formRefs.current['REORDERMAXIMUMDAYSONHAND'].instance().option('disabled', true);
            if (formRefs.current['REORDERQUANTITYENTERED'])
                formRefs.current['REORDERQUANTITYENTERED'].instance().option('disabled', true);
            if (formRefs.current['REORDERQUANTITYEOQCALCULATED'])
                formRefs.current['REORDERQUANTITYEOQCALCULATED'].instance().option('disabled', true);
            if (formRefs.current['REORDERQUANTITYORDERMULTIPLE'])
                formRefs.current['REORDERQUANTITYORDERMULTIPLE'].instance().option('disabled', true);
            if (formRefs.current['REORDERSAFETYQUANTITY'])
                formRefs.current['REORDERSAFETYQUANTITY'].instance().option('disabled', true);
            if (formRefs.current['REORDERLEADTIME'])
                formRefs.current['REORDERLEADTIME'].instance().option('disabled', true);
            if (formRefs.current['WARRANTYMONTHS'])
                formRefs.current['WARRANTYMONTHS'].instance().option('disabled', true);
            if (formRefs.current['MAXDAYS'])
                formRefs.current['MAXDAYS'].instance().option('disabled', true);
        }
    }
    const handleStatusFieldChange=(name, value)=>{
        if (name == "REORDERMETHODFLAG" && value == "N" && value != undefined) {
            formRefs.current['REORDERINVENTORYMINIMUMQTY'].instance().option('disabled', true);
            formRefs.current['REORDERINVENTORYMAXIMUMQTY'].instance().option('disabled', true);
            formRefs.current['REORDERMINIMUMDAYSONHAND'].instance().option('disabled', true);
            formRefs.current['REORDERMAXIMUMDAYSONHAND'].instance().option('disabled', true);
            formRefs.current['REORDERQUANTITYENTERED'].instance().option('disabled', true);
            formRefs.current['REORDERQUANTITYEOQCALCULATED'].instance().option('disabled', true);
            formRefs.current['REORDERQUANTITYORDERMULTIPLE'].instance().option('disabled', true);
            formRefs.current['REORDERSAFETYQUANTITY'].instance().option('disabled', true);
            formRefs.current['REORDERLEADTIME'].instance().option('disabled', true);
            
            formRefs.current['REORDERINVENTORYMINIMUMQTY'].instance().option('value', null);
            formRefs.current['REORDERINVENTORYMAXIMUMQTY'].instance().option('value', null);
            formRefs.current['REORDERMINIMUMDAYSONHAND'].instance().option('value', null);
            formRefs.current['REORDERMAXIMUMDAYSONHAND'].instance().option('value', null);
            formRefs.current['REORDERQUANTITYENTERED'].instance().option('value', null);
            formRefs.current['REORDERQUANTITYEOQCALCULATED'].instance().option('value', null);
            formRefs.current['REORDERQUANTITYORDERMULTIPLE'].instance().option('value', null);
            formRefs.current['REORDERSAFETYQUANTITY'].instance().option('value', null);
            formRefs.current['REORDERLEADTIME'].instance().option('value', null);

        }else if (name == "REORDERMETHODFLAG" && value != "N" && value != undefined){
            formRefs.current['REORDERINVENTORYMINIMUMQTY'].instance().option('disabled', false);
            formRefs.current['REORDERINVENTORYMAXIMUMQTY'].instance().option('disabled', false);
            formRefs.current['REORDERMINIMUMDAYSONHAND'].instance().option('disabled', false);
            formRefs.current['REORDERMAXIMUMDAYSONHAND'].instance().option('disabled', false);
            formRefs.current['REORDERQUANTITYENTERED'].instance().option('disabled', false);
            formRefs.current['REORDERQUANTITYEOQCALCULATED'].instance().option('disabled', false);
            formRefs.current['REORDERQUANTITYORDERMULTIPLE'].instance().option('disabled', false);
            formRefs.current['REORDERSAFETYQUANTITY'].instance().option('disabled', false);
            formRefs.current['REORDERLEADTIME'].instance().option('disabled', false);
        }  

        if (name == "CHECKRECEIPTDAYS" && value == "1" && value != undefined) {
            formRefs.current['WARRANTYMONTHS'].instance().option('disabled', true);
            formRefs.current['WARRANTYMONTHS'].instance().option('value', null);

        }else if (name == "CHECKRECEIPTDAYS" && value != "1" && value != undefined){
            formRefs.current['WARRANTYMONTHS'].instance().option('disabled', false);
        }

        if (name == "CHECKMAXDAYS" && value == "1" && value != undefined) {
            formRefs.current['MAXDAYS'].instance().option('disabled', true);
            formRefs.current['MAXDAYS'].instance().option('value', null);

        }else if (name == "CHECKMAXDAYS" && value != "1" && value != undefined){
            formRefs.current['MAXDAYS'].instance().option('disabled', false);
        }
    }
 
    // Status Tab End

    //HandlingTab////////////////////////
    const handlingFormLookupsLoad =() => {
        handlingFormLoad();
    }
    const handlingFormLoad=()=>{
        loadLookupFromStaticData(formRefs,"SUBLOTUNIQUEFLAG",[{id:'N',name:"Not Applicable"},{id:'Y',name:"All Sublots Created Will Be Assumed To Be Unique & Always Have a Quantity Of One"}]);
        loadLookupFromStaticData(formRefs,"HAZARDOUSFLAG",[{id:'N',name:"No"},{id:'Y',name:"Yes"}]);
        loadLookupFromStaticData(formRefs,"SHIPSELECTION",[{id:'N',name:"No, Serial # In Transaction Entry "},{id:'Y',name:"Yes, Use Serial # In Transaction Entry - Update Weights In Detail Based On Serial #"},{id:'U',name:"Yes, Use Serial # In Transaction Entry - Do Not Update Weights In Detail Based On Serial # "}]);
    }
   


 
    const handleHandlingFieldChange=(name, value)=>{
        if (name == "R_WAREHOUSE") {
            setformFields(prevFields => ({
                ...prevFields,
                R_LOCATION: '',
                R_LOCATIONBACKUPFORWARDPICK: '',
                R_LOCATIONBACKUPREPLENSMENT: '',
                R_LOCATIONBACKUPRESERVE: '',
                R_LOCATIONPRIMARYRESERVE: '',
                R_LOCATIONPRIMARYREPLENSMENT: '',
            }));

        }
        if (name == "HAZARDOUSFLAG" && value == "N" && value != undefined) {

            formRefs.current['R_HAZARDOUS'].instance().option('disabled', true);
            formRefs.current['R_HAZARDOUS'].instance().option('value', null);
        }else if (name == "HAZARDOUSFLAG" && value != "N" && value != undefined){
            formRefs.current['R_HAZARDOUS'].instance().option('disabled', false);
        }  
    }
    const kitFormLookupsLoad =() => {
        KitFormLoad();
    }
    const KitFormLoad=()=>{
    }
    const handleKitFieldChange=(name, value)=>{
        
    }
    //HandlingTab////////////////////////
        const handleSelectionChange = useCallback((name, e) => {
        }, []);
    return (
        <div>
            <div className="row dataEntryMainPage">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            position={position}
                            onHiding={hideLoadPanel}
                            visible={loadPanelVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
                        <form onSubmit={(e) => handleFormSubmit(e)}>
                            <Toolbar className="header">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2,
                                                marginLeft: '12px'
                                            }}
                                        >
                                            Item Data Entry
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button
                                        text="Save"
                                        useSubmitBehavior={true}
                                        disabled={isFormSubmitted}
                                        type="default"
                                        className="accordianButton"
                                    />
                                </Item>
                                <Item location="after">
                                    {/* Delphi strips abAdd (and the rest of the navigator) when the
                                        form is opened on a profile-defaults record: a profile has
                                        exactly one, so there is nothing to add. */}
                                    <Button className="accordianButton" onClick={addNewRecordClick} text="New" type="default" visible={!isProfileDefaults} />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={DeleteClick} text="Delete" disabled={formFields.ROWID === "00000000-0000-0000-0000-000000000000"} type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={goBack} text="Back" />
                                </Item>
                            </Toolbar>
                                <TabPanel deferRendering={props.id?true:false} showNavButtons={true} height={"auto"}>
                                    <TabItem title="Primary">
                                        <PrimaryTab formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} handleSelectionChange={handleSelectionChange} primaryFormLookupsLoad={primaryFormLookupsLoad} formRefs={formRefs}/>
                                    </TabItem>
                                    <TabItem title="Additional" >
                                        <AdditionalTab formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} handleSelectionChange={handleSelectionChange} additionalFormLookupsLoad={additionalFormLoad} formRefs={formRefs}/>
                                    </TabItem>
                                    <TabItem title="UOM" >
                                        <UOMTab formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} handleSelectionChange={handleSelectionChange} handleUOMFormLoad={handleUOMFormLoad} formRefs={formRefs} />
                                    </TabItem>
                                    <TabItem title="Handling">
                                         <HandlingTab formFields={formFields} setformFields={setformFields} handleHandlingFieldChange={handleHandlingFieldChange} handlingFormLookupsLoad={handlingFormLookupsLoad}  formRefs={formRefs}  />
                                    </TabItem>
                                    <TabItem title="Status">
                                         <StatusTab formFields={formFields} setformFields={setformFields} handleStatusFieldChange={handleStatusFieldChange} statusFormLookupsLoad={statusFormLookupsLoad}  formRefs={formRefs}/>
                                    </TabItem>
                                    <TabItem title="User Defined">
                                        <UserDefinedTab formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} handleSelectionChange={handleSelectionChange} formRefs={formRefs} />
                                    </TabItem>
                                    <TabItem title="Lots">
                                        <LotTab rowId={formFields.ROWID} />
                                    </TabItem>
                                    <TabItem title="Locations">
                                        <LocationsTab itemRowId={formFields.ROWID} type='item'  />
                                    </TabItem>
                                    <TabItem title="Serial #" >
                                        <SerialNumberTab sourceId={formFields.ROWID}  formRefs={formRefs} type='item' />
                                    </TabItem>
                                    <TabItem title="Charges">
                                          <ChargesTab sourceId={formFields.ROWID}  formRefs={formRefs}  type='item' />
                                    </TabItem>
                                    <TabItem title="Unavailable">
                                        <UnavailableTab itemRowId={formFields.ROWID}  type='item' />
                                    </TabItem>
                                    <TabItem title="Kit" >
                                         <KitTab formFields={formFields} setformFields={setformFields} handleKitFieldChange={handleKitFieldChange} kitFormLookupsLoad={kitFormLookupsLoad}  formRefs={formRefs}  />
                                    </TabItem>
                                </TabPanel>
                                <div className="row">
                                 <ValidationSummary className="pl-3 pt-1" id="summary" />
                               </div>
                        </form>
                    </div>

                </div>
            </div>

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(Form);
